import Widget from '@/plugins/dashboard/widgets/Items/Widget'
import Configure from '@/plugins/dashboard/widgets/Items/Configure'
import Chart from '@/plugins/dashboard/classes/Chart'

export default class extends Chart {
  static name = 'Items'
  static widget = Widget
  static configure = Configure
}
